import { Token } from "hooks/query/useTokens";

function getNetworkTokens(chainId: number, tokens: Token[]) {
  return tokens.filter((token) => token[chainId]);
}

export default getNetworkTokens;
